// extracted by mini-css-extract-plugin
export default {"-large":"DmCCxbJm3cg_4pcsyFWF","signupFormGridItem":"RPxIV6yA9sHuqUWJ6Y7h"};